import { useEffect, useState } from 'react'

/**
 * Whether a horizontal scroll container is actually wider inside than it is on
 * screen. Watches the container and its content, because the overflow depends
 * on the data (long amounts widen a table) as much as on the viewport.
 */
export function useHorizontalOverflow(element: HTMLElement | null): boolean {
    const [overflowing, setOverflowing] = useState(false)
    useEffect(() => {
        if (!element) return
        const measure = () =>
            setOverflowing(element.scrollWidth > element.clientWidth)
        measure()
        if (typeof ResizeObserver === 'undefined') return
        const observer = new ResizeObserver(measure)
        observer.observe(element)
        if (element.firstElementChild)
            observer.observe(element.firstElementChild)
        return () => observer.disconnect()
    }, [element])
    return overflowing
}
